import { pushFirebaseConfig } from './configFirebase'
import { FirebaseApp, initializeApp } from 'firebase/app'

let pushApp: FirebaseApp | undefined = undefined
const initializePushApp = async (): Promise<void> => {
  try {
    pushApp = initializeApp(pushFirebaseConfig, 'firebase-push')
  } catch (err) {
    console.error(err)
  }
}

export { initializePushApp, pushApp }
